import { useTranslation } from "react-i18next"
import HasPermission, { CanViewCompanyDetail } from "app/PermissionChecker"
import { useGetCompanyFileStatsQuery } from "../api/companyApiSlice"


export default function CompanyFileStats() {

    const [t, i18n] = useTranslation("global")
    const canViewCompanyLog = HasPermission(CanViewCompanyDetail)

    const {
        data: statsData,
        isFetching: statsIsFetching,
        isSuccess: statsIsSuccess,
        isLoading: statsIsLoading,
        isError: statsIsError,
        error: statsError,
        refetch: statsRefetch,
    } = useGetCompanyFileStatsQuery()

    return <div className="card bg-black bg-opacity-10 text-white mb-4">
        <div className="card-header">
            <i className="fa-solid fa-floppy-disk"></i> Storage

        </div>
        {
            statsIsSuccess &&
            <div className="card-body text-center ">
                <div className="row">
                    <div className="col">
                        <span className="text-muted">Files</span><br />
                        <h3><i className="fa-solid fa-folder-open"></i> {statsData.count} </h3>
                    </div>
                    <div className="col">
                        <span className="text-muted">Space</span><br />
                        <h3><i className="fa-solid fa-database"></i> {statsData.amount}</h3>
                    </div>
                </div>
            </div>
        }

    </div>


}